import { Platform } from 'react-native';

// Dynamic styles based on theme - to be used with useThemedStyles.
export const createStopViewStyles = ({ ui: { colors, type, space, radius, touch } }) => ({
	place: {
		gap: 6,
	},
	siteName: {
		...type.title,
		color: colors.text,
		flex: 1,
		// Shared Text cap-centres on phones; web's Sofia capitals sit 2px higher.
		paddingTop: (touch.min - type.title.lineHeight) / 2 + (Platform.OS === 'web' ? 2 : 0),
	},
	copyRow: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		gap: space.sm,
	},
	copyTarget: {
		width: touch.min,
		height: touch.min,
		flexShrink: 0,
		alignItems: 'center',
		justifyContent: 'center',
	},
	copyButton: {
		width: 40,
		height: 40,
		borderRadius: radius.control,
		backgroundColor: colors.chip,
		borderWidth: 1,
		borderColor: colors.accent,
		alignItems: 'center',
		justifyContent: 'center',
	},
	address: {
		...type.bodySmall,
		color: colors.accent,
		textDecorationLine: 'underline',
		flex: 1,
		paddingTop: (touch.min - type.bodySmall.lineHeight) / 2 + (Platform.OS === 'web' ? 1 : 0),
	},
	positionName: {
		...type.cardTitle,
		color: colors.text,
	},
	machineLine: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		alignItems: 'center',
		gap: space.sm,
		marginTop: space.xs,
	},
	machineDetails: {
		...type.bodySmall,
		color: colors.textSecondary,
		flexShrink: 1,
	},
	tags: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: 6,
		marginTop: space.xs,
	},
	section: {
		gap: space.sm,
	},
	skip: {
		gap: space.xs,
	},
	secondaryText: {
		...type.secondary,
		color: colors.textSecondary,
	},
	quickActions: {
		flexDirection: 'row',
		gap: space.sm,
	},
	quickAction: {
		flex: 1,
	},
});
